<template>
  <div id="app">
    <Header v-if="showHead"></Header>
    <div class="layout-page" :class="{'page-with-contextual-sidebar': showBar}">
      <LeftSidebar v-if="showBar"></LeftSidebar>
      <router-view/>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import LeftSidebar from './components/LeftSidebar.vue'
export default {
  name: 'App',
  components:{
    Header,
    LeftSidebar
  },
  computed: {
    logined () {
      return this.$store.state.user.login
    },
    showBar() {
      return this.logined
    },
    showHead(){
      return this.logined
    }
  }
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  min-width: 1024px;
  min-height: 743px;
}
.layout-page{
  height: 100%;
}
html, body{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue